import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { assert } from "@/common/assert";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import { TypedMessage } from "leancloud-realtime";
import { FhtCustomMessage } from "./FhtCustomMessage";
import { registerCustomMessage } from "../messageTypeHelper";

var CustomProductMessage =
/** @class */
function (_super) {
  __extends(CustomProductMessage, _super);

  function CustomProductMessage(attrs) {
    return _super.call(this, attrs) || this;
  }

  CustomProductMessage.parse = function (json) {
    assert(json, "json falsy");
    var attrs = json._lcattrs;
    var m = new CustomProductMessage(attrs);
    return TypedMessage.parse(json, m);
  };

  return CustomProductMessage;
}(FhtCustomMessage);

export default CustomProductMessage;
registerCustomMessage(CustomProductMessage, FhtLeancloudCustomMessageType.Product, {
  PRODUCT_NAME_KEY: true,
  PRODUCT_TITLE_KEY: true,
  PRODUCT_CONTENT_KEY: true,
  PRODUCT_IMAGE_URL_KEY: true,
  PRODUCT_ID_KEY: true
});